<template>
    <div :class="'column is-3'">
        <div class="app-block">
            <div class="school-border" :class="schoolSlug"></div>
            <div class="p-md">

                <div class="has-text-centered">
                    <div class="profile-image">
                        <img v-if="profile_photo" width="200" height="300"
                             :src="'/profiles/'+profile_photo">
                        <img width="150" height="300" v-else
                             :src="'/img/icons/image.png'">
                    </div>
                </div>


                <div class="has-text-centered">
                    <div class="has-text-weight-bold candidate-name">{{ candidate.first_name }} <span
                            class="is-uppercase">{{ candidate.last_name }}</span></div>
                    <i>{{ candidate.email }}</i>
                    <ul class="">

                        <li>{{ candidate.phone }}</li>
                        <li>
                            <div>{{ candidate.address }}</div>
                            <div>{{ candidate.post_code }}, {{ candidate.city }}</div>
                        </li>
                    </ul>
                </div>
                <br>
                <div class="has-text-right">
                    <button class="button" @click="edit">
                        {{ $t('labels.general.edit') }}
                    </button>
                </div>

                <br>

            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                profile_photo: ''
            }
        },
        props: {
            school: { type: Object },
            schoolSlug: {type: String},
            candidate: { type: Object },
            singleApplication: { type: Object }
        },
        computed: {
            application () {
                return this.candidate.applications
            },
            registered () {
                return this.application.registration && this.application.registration.registered_candidate
            }
        },
        methods: {
            edit: function () {
                this.$emit('edit')
            },
        },
        mounted () {
            this.profile_photo = this.candidate.profile_photo
        }

    }
</script>
